import {Stack, Title} from '@mantine/core';
import {SessionDebugInfo} from '../sessions/SessionDebugInfo';
import {useAccounts} from '../../accounts/hooks/useAccounts';
import {useEffect} from 'react';

export const SessionsTab = () => {
    const {accounts, handleFetchAccounts} = useAccounts();

    useEffect(() => {
        handleFetchAccounts();
    }, []);

    return (
        <Stack gap="md">
            <Title order={2}>Sessions</Title>
            <SessionDebugInfo accounts={accounts} />
        </Stack>
    );
};
